import React, { useState, useEffect } from 'react';
import * as FiIcons from 'react-icons/fi';
import ModuleLayout from '../common/ModuleLayout';

const { FiTrendingUp } = FiIcons;

const ModuleFour = ({ data, onSave, completed }) => {
  const [formData, setFormData] = useState({
    bestWritingTimes: '',
    bestWritingLocations: '',
    restartPlan: '',
    reframeStatement: 'Faithful progress matters more than perfect consistency.'
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (data) setFormData(prev => ({ ...prev, ...data }));
  }, [data]);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleSave = async (markComplete) => {
    setIsLoading(true);
    setTimeout(() => {
      onSave(formData, markComplete);
      setIsLoading(false);
    }, 800);
  };

  const canComplete = formData.restartPlan && formData.restartPlan.trim() !== '';

  return (
    <ModuleLayout
      title="Sustain Momentum"
      description="Design a writing rhythm that supports faithfulness over perfection."
      icon={FiTrendingUp}
      onSave={handleSave}
      completed={completed}
      canComplete={canComplete}
      isLoading={isLoading}
    >
      <div className="space-y-8">
        <div className="bg-white rounded-2xl shadow-sm p-8 border border-slate-100">
          <label className="block text-lg font-bold text-slate-800 mb-4">Guilt-Free Restart Plan</label>
          <p className="text-slate-500 mb-4">How will you gracefully return to writing after a break or setback?</p>
          <textarea
            value={formData.restartPlan}
            onChange={(e) => handleInputChange('restartPlan', e.target.value)}
            rows={4}
            className="w-full p-4 bg-slate-50 border border-slate-100 rounded-xl focus:ring-2 focus:ring-blue-500 focus:bg-white transition-all resize-none"
            placeholder="I will start with just 10 minutes..."
          />
        </div>
        <div className="bg-white rounded-2xl shadow-sm p-8 border border-slate-100">
          <label className="block text-lg font-bold text-slate-800 mb-4">Your Reframe Statement</label>
          <textarea
            value={formData.reframeStatement}
            onChange={(e) => handleInputChange('reframeStatement', e.target.value)}
            rows={3}
            className="w-full p-4 bg-slate-50 border border-slate-100 rounded-xl focus:ring-2 focus:ring-blue-500 focus:bg-white transition-all resize-none font-medium italic"
          />
        </div>
      </div>
    </ModuleLayout>
  );
};

export default ModuleFour;